.popover {
	display: flex;
	flex-direction: column;
	min-height: 0;
	gap: var(--size-5);
	padding: var(--size-4);
	width: 30rem;
}

.group {
	display: flex;
	align-items: center;
	gap: var(--size-3);
	width: 100%;

	.text {
		flex: 1;
		min-width: 0;
	}

	> svg {
		color: var(--color-primary);
		flex-shrink: 0;
	}

	button:where(:hover, :focus-visible) & > svg {
		color: var(--gray-200);
	}
}
